<div class="layout_content" id="layout-top">
  <div class="container_statics">
    <app-breadcrumb></app-breadcrumb>
    <article>
      <iframe id="AuthorizationPolicy"
        title="Autorización para el tratamiento de datos personales"
        src="https://novedades.jelpit.com/tratamiento-de-datos-seccion-aliados/">
      </iframe>
    </article>
  </div>
</div>
